import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import EsgDashboard from "./pages/Esg/EsgDashboard";
import FintechDashboard from "./pages/Fintech/FintechDashboard";
import StateInitiativeDashboard from "./pages/StateInitiative/StateInitiative";
import StateOrganisationsDashboard from "./pages/StateInitiative/StateOrganisations";

const App: React.FC = () => {
  return (
    <Router future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/esg" element={<EsgDashboard />} />
        <Route path="/finTech" element={<FintechDashboard />} />
        <Route
          path="/weakSignals"
          element={<FintechDashboard isWeakSignals={true} />}
        />
        <Route
          path="/state_initiative"
          element={<StateInitiativeDashboard />}
        />
        <Route
          path="/crgci_organizations"
          element={<StateOrganisationsDashboard />}
        />
      </Routes>
    </Router>
  );
};

export default App;
